// extracted by mini-css-extract-plugin
export default {"starRatingContainer":"C_cp","inactive":"C_k","fullStar":"C_cq","text":"C_cr","labelMiddle":"C_cs"};